import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import MaterialIcon from 'material-icons-react';
import { PermissionEnum } from '../../../shared/models/permissions';
import ShowIfPermission from '../../../shared/show-if-permission/ShowIfPermission';
import Divider from '@material-ui/core/Divider';
import {
    isAuditEnabled,
    isClientAccessEnabled,
    isSimulationEnabled
} from '../../../shared/feature-flags';
import './Menu.scss';

class MonitorPlayersMenu extends Component {
    render() {
        return (
            <div className="menu">
                {/*<span className='menu-title'>Monitor Players</span>*/}

                <NavLink
                    className="menu-item"
                    to="/dashboard"
                    isActive={(match, location) => {
                        if (!match) {
                            return location.pathname === '/';
                        } else {
                            return true;
                        }
                    }}
                >
                    <MaterialIcon color="inherit" icon="dashboard" />
                    <div className="menu-item-text">Dashboard</div>
                </NavLink>

                <NavLink
                    className="menu-item"
                    to="/alerts/anti-money-laundering"
                >
                    <MaterialIcon
                        color="inherit"
                        icon="notification_important"
                    />
                    <div className="menu-item-text">Alerts</div>
                </NavLink>

                <NavLink className="menu-item" to="/risk-assessment">
                    <MaterialIcon color="inherit" icon="speed" />
                    <div className="menu-item-text">Risk</div>
                </NavLink>

                <NavLink className="menu-item" to="/players">
                    <MaterialIcon color="inherit" icon="portrait" />
                    <div className="menu-item-text">Players</div>
                </NavLink>
                <ShowIfPermission permission={PermissionEnum.MANAGE_USERS}>
                    <Divider className={'section-divider'} />
                    <NavLink className="menu-item" to="/teams">
                        <MaterialIcon color="inherit" icon="group" />
                        <div className="menu-item-text">Teams</div>
                    </NavLink>

                    <NavLink className="menu-item" to="/users">
                        <MaterialIcon color="inherit" icon="person" />
                        <div className="menu-item-text">Users</div>
                    </NavLink>

                    {isClientAccessEnabled() && (
                        <NavLink className="menu-item" to="/client-access">
                            <MaterialIcon color="inherit" icon="vpn_key" />
                            <div className="menu-item-text">API user access</div>
                        </NavLink>
                    )}
                </ShowIfPermission>
                {isAuditEnabled() && (
                    <ShowIfPermission
                        permission={PermissionEnum.VIEW_AUDIT_LOG}
                    >
                        <NavLink className="menu-item" to="/audit">
                            <MaterialIcon color="inherit" icon="history" />
                            <div className="menu-item-text">Audit</div>
                        </NavLink>
                    </ShowIfPermission>
                )}
                {isSimulationEnabled() && (
                    <ShowIfPermission
                        permission={PermissionEnum.MANAGE_SIMULATIONS}
                    >
                        <Divider className={'section-divider'} />
                        <NavLink className="menu-item" to="/simulations">
                            <MaterialIcon color="inherit" icon="science" />
                            <div className="menu-item-text">Simulation</div>
                        </NavLink>
                    </ShowIfPermission>
                )}
            </div>
        );
    }
}

export default MonitorPlayersMenu;
